import { z } from 'zod';

import { dataWithFiles, useAxleMutation, useAxleQuery } from '../apiHelpers';

export type ObjectForDocument = { objectId: string; objectType: 'patient' | 'visit' };

export const useUploadDocumentOptions = ({ objectId, objectType }: ObjectForDocument) =>
    useAxleQuery({
        path: `/upload-document/options`,
        params: {
            object_id: objectId,
            object_type: objectType,
        },
        suspense: true,
        responseSchema: z.object({
            doc_types: z.array(
                z.object({
                    code: z.string(),
                    name: z.string(),
                }),
            ),
        }),
    }).data;

export const useUploadDocument = ({ objectId, objectType }: ObjectForDocument) =>
    useAxleMutation({
        axiosConfig: ({ docFile, docType }: { docFile: File; docType: string }) => ({
            method: 'post',
            path: `/upload-document`,
            data: dataWithFiles({
                object_id: objectId,
                object_type: objectType,
                doc_file: docFile,
                doc_type: docType,
            }),
        }),
        softResetQueries: [
            // We only actually need to reset one of them, but hard to express that conditionally,
            //  and it's safe enough to just reset both queries.
            ['visit', objectId],
            ['patient', objectId],
        ],
    });
